{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Farvevælger",
  "twoDimensionalSlider": "2D-skyder"
}
